import { IApiService } from 'src/services/IApiService';
import { observable } from 'mobx';
import Historie from '../models/Historie';

export default class HistorieStore {
    @observable public historieForID: Historie[] = [];

    private api: IApiService;
    constructor(api: IApiService) {
        this.api = api;
    }

    public loadOrderHistory(orderId: number): Promise<boolean> {
        return new Promise(resolve => {
            this.api.getOrderHistory(orderId).then((value: Historie[]) => {
                this.historieForID = value;
                resolve(true);
            })
        });
    }

    public loadClientHistory(clientId: number): Promise<boolean> {
        return new Promise(resolve => {
            this.api.getClientHistory(clientId).then((value: Historie[]) => {
                this.historieForID = value;
                resolve(true);
            })
        });
    }
}



// WEBPACK FOOTER //
// ./src/stores/HistorieStore.tsx